var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main--text mb-12",attrs:{"fluid":""}},[_c('h1',{staticClass:"page-title text-center"},[_vm._v("Dash Waste FAQs")]),_c('faqs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }